import React, { Component } from 'react'
import firebase from '../../config/database'
import Indicator from '../Indicator'
import * as FontAwesome from 'react-icons/fa';
import * as MaterialIcons from 'react-icons/md';
import * as Ionicons from 'react-icons/io';
import * as Feather from 'react-icons/fi';
import PropTypes from 'prop-types';

class Uploadfile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      isLoading: false,
      numPages: null,
      pageNumber: 1,
    };
    this.handleChange = this.handleChange.bind(this);
    this.submitImageToFirebase = this.submitImageToFirebase.bind(this);
    this.saveImageLinkInFirebase = this.saveImageLinkInFirebase.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.value !== prevProps.value) {
      this.setState({
        value: this.props.value
      });
    }
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  }
  saveImageLinkInFirebase(link) {
    console.log(link);
    this.setState({ isLoading: false });
    this.props.updateAction(this.props.theKey, link);
  }

  submitImageToFirebase(value) {
    var _this = this;
    // Create a root reference
    console.log(this.props.path);
    var storageRef = firebase.app.storage().ref(this.props.path);
    var refFile = new Date().getTime() + ".pdf"

    // Create a reference to 'mountains.jpg'
    var newImageRef = storageRef.child(refFile);
    var stripedImage = value.substring(value.indexOf('base64') + 7, value.length);

    newImageRef.putString(stripedImage, 'base64').then(function (snapshot) {
      console.log('Uploaded a base64 string!');
      snapshot.ref.getDownloadURL().then(function (downloadURL) {
        _this.saveImageLinkInFirebase(downloadURL);
      });
    });
  }

  handleChange(e) {
    this.setState({ isLoading: true });
    e.preventDefault();
    console.log("Start processing ....")

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      console.log("Image is in base 64 now.. Upload it");
      this.setState({
        file: file,
        value: reader.result
      });
      this.submitImageToFirebase(reader.result)

    }

    reader.readAsDataURL(file)

  }
  render() {
    const { pageNumber, numPages } = this.state;

    var imgSrc = this.state.value;
    // console.log("In file upload");
    // console.log(imgSrc);
    return (
      <div className="col-md-12 fileinput fileinput-new text-center" data-provides="fileinputaa">
        {imgSrc.length > 0 ?
          <div><a href={imgSrc} className="fileinput-new" target="_blank">
            View PDF</a>
          </div> : null}
        <div className="fileinput-preview fileinput-exists thumbnail"></div>
        <div className="col-md-12">
          <span className={"btn btn-rose btn-round btn-file"}>
            <span className="fileinput-new">{imgSrc.length > 0 ? "Change" : "Add"} PDF</span>
            <span className="fileinput-exists">Change</span>
            <input type="file" accept="application/pdf" style={{ width: '2000px' }} id={this.props.theKey} name={this.props.theKey} onChange={this.handleChange} />
          </span>
          <Indicator show={this.state.isLoading} />
          <a href="#pablo" className="btn btn-danger btn-round fileinput-exists" data-dismiss="fileinput"><i className="fa fa-times"></i> Remove</a>
        </div>
      </div>
    )

  }
}
export default Uploadfile;

Uploadfile.propTypes = {
  updateAction: PropTypes.func.isRequired,
  theKey: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  class: PropTypes.string,
  wrapperClass: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/fields/fileupload.js